/**
 * Navegação master: balão da timeline → editor do chatbot (passo URA).
 */

export function getUraSlotFromMessage(message) {
  if (!message || typeof message !== "object") return null;
  const direct = message.uraSlot;
  if (direct && Number(direct.slotId) > 0 && Number(direct.chatbotUserId) > 0) {
    return {
      slotId: Number(direct.slotId),
      chatbotUserId: Number(direct.chatbotUserId),
    };
  }
  const raw = message.json_whatsapp ?? message.jsonWhatsapp;
  if (!raw) return null;
  let obj = raw;
  if (typeof raw === "string") {
    try {
      obj = JSON.parse(raw);
    } catch {
      return null;
    }
  }
  const nav = obj?.xpro_ura_nav;
  if (!nav || typeof nav !== "object") return null;
  const role = nav.role === "inbound" ? "inbound" : "outbound";
  const slotId =
    role === "inbound"
      ? Number(nav.matchedSlotId) || Number(nav.slotId) || 0
      : Number(nav.slotId) || Number(nav.matchedSlotId) || 0;
  let chatbotUserId = Number(nav.chatbotUserId) || 0;
  if (!chatbotUserId && Number(message.uraUser) === 1 && Number(message.id_usuario) > 0) {
    chatbotUserId = Number(message.id_usuario);
  }
  if (!slotId || !chatbotUserId) return null;
  return { slotId, chatbotUserId };
}

export function buildChatbotSlotEditorPath(chatbotUserId, slotId) {
  const uid = Number(chatbotUserId);
  const sid = Number(slotId);
  if (!uid || !sid) return null;
  return `/chatbots/${uid}?slot=${sid}`;
}
